import type { FC } from 'react'

import type { EmailCaptureFormProps } from '@segment/templates/Forms/EmailCaptureForm'
import EmailCaptureForm from '@segment/templates/Forms/EmailCaptureForm'

import SuccessMessage from './SuccessMessage'

type EmailFormProps = EmailCaptureFormProps

const copy = {
  buttonText: `Subscribe`,
  inputPlaceholder: `Your email address`,
}
const CUSTOM_FORM_IDENTIFIER = `1164`

const EmailForm: FC<EmailFormProps> = (props) => {
  return (
    <EmailCaptureForm
      buttonText={copy.buttonText}
      customFormIdentifier={CUSTOM_FORM_IDENTIFIER}
      inputProps={{ placeholder: copy.inputPlaceholder }}
      success={<SuccessMessage />}
      {...props}
    />
  )
}

export default EmailForm
